
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCusSaleComparisonDialog extends Serenity.EntityDialog<ReportCusSaleComparisonRow, any> {
        protected getFormKey() { return ReportCusSaleComparisonForm.formKey; }
        protected getIdProperty() { return ReportCusSaleComparisonRow.idProperty; }
        protected getLocalTextPrefix() { return ReportCusSaleComparisonRow.localTextPrefix; }
        protected getNameProperty() { return ReportCusSaleComparisonRow.nameProperty; }
        protected getService() { return ReportCusSaleComparisonService.baseUrl; }
        protected getDeletePermission() { return ReportCusSaleComparisonRow.deletePermission; }
        protected getInsertPermission() { return ReportCusSaleComparisonRow.insertPermission; }
        protected getUpdatePermission() { return ReportCusSaleComparisonRow.updatePermission; }

        protected form = new ReportCusSaleComparisonForm(this.idPrefix);

    }
}